<template>
  <div
      class="d-flex justify-content-center align-items-center fs-1 bg-dark">
      <i class="bi bi-eye-slash"></i>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
  }
})
export default class PhotoListHomeItemEmpty extends Vue {
}
</script>

<style lang="stylus">
</style>
